import { SvgInputControl } from './SvgInputControl';
import { WebsitePlugin } from '@gift/types/WebsitePlugin';
import { svgToFfCanvas } from '@gift/svg-core/svgToFfCanvas';
import { SvgVariableOptions } from '@gift/svg-core/SvgVariableOptions';
import { SvgVariableInput } from '@gift/svg-core/SvgVariableInput';

export const svgWebsitePlugin: WebsitePlugin.Variable<SvgVariableOptions, SvgVariableInput> = {
    pluginId: 'svg',
    InputControl: SvgInputControl,
    toFfCanvas: svgToFfCanvas
};